<style type="text/css">
  .loadercenter {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }

  .overlay {
    position: fixed;
    display: block;
    width: 100%;
    height: 100%;
    top: 0;
    left: 0;
    /* background-color: black; */
    z-index: 99999;
  }

  div.item {
    vertical-align: top;
    display: inline-block;
    text-align: center;
    width: 120px;
  }
</style>
<div class="fresh-ui">
  <section class="mater-categories">
    <div class="container">
      <div class="banner-content">
        <div class="category-title r-slab text-center text-center">
          {{ categoryNameTitle }} Invitations
        </div>
        <div class="row justify-content-center mt-3">
          <div
            class="col-md-auto moduleContainer"
            [class.show]="categorydata?.IsShowMore"
          >
            <div
              [innerHTML]="VideoFilterModel.SubcategoryId == 0 ? currentCategory?.CategoryDescription : currentCategory?.SubCategoryDescription"
              class="general_sans text-center"
            ></div>
          </div>
          <a
            role="button"
            class="btn-showcontent"
            (click)="changeContentVisibility(categorydata)"
            >{{
              categorydata?.IsShowMore
                ? "Show less"
                : "Show
                        More"
            }}
          </a>
        </div>
      </div>
    </div>
  </section>
  <section class="section-videos">
    <div class="filters-sidebar">
      <div class="fs-title">
        {{ categoryName }}
      </div>

      <div
        class="filter-list-card"
        *ngFor="let subCategoryDataItem of videoCategoryData"
      >
        <label class="mb-0">
          <input
            type="checkbox"
            [value]="subCategoryDataItem.Id"
            [checked]="subCategoryDataItem?.IsSelected"
            (change)="toggleSelection(subCategoryDataItem)"
          />
          {{ subCategoryDataItem?.Name }}
        </label>
      </div>
      <div class="fs-title mt-5">Sort by</div>
      <div
        class="filter-list-card"
        *ngFor="let sortByItem of soryByData"
        (click)="setSortFilter(sortByItem)"
      >
        {{ sortByItem.Name }}
      </div>

      <div class="fs-title mt-5">Photo</div>
      <div
        class="filter-list-card"
        *ngFor="let photoItem of photoFilterData"
        (click)="setPhotoFilter(photoItem)"
      >
        {{ photoItem.Name }}
      </div>
    </div>
    <div
      class="video-card-area"
      *ngIf="AllVideoData != null && AllVideoData.length > 0"
    >
      <!-- <div class="applied-filters d-none d-md-flex">
                <div class="applied-filter-card"
                    *ngFor="let selectedItem of selectedTag">
                    <span class="filter-text">
                        {{selectedItem.Name}}
                    </span>
                    <span class="clear-btn">
                        <span class="material-icons"
                            (click)="removeTag(selectedItem)">
                            close
                        </span>
                    </span>
                </div>
                <div class="btn-clear-filter" *ngIf="selectedTag?.length > 0"
                    (click)="clearFilter()">
                    Clear filter
                </div>
            </div> -->
      <div class="filters-bar-mobile d-md-none d-flex">
        <a class="parent-category-name" href="#">
          <span class="text-dark cat-name">{{ categoryName }}</span>
        </a>

        <div
          id="filters-toggle-mobile"
          class="d-flex"
          (click)="ShowMobileFiltersDialog()"
        >
          <svg
            width="20px"
            height="20px"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="fui-mx-2 fui-h-6 fui-w-6"
          >
            <path
              d="M5.451 20.003v-6.002M5.451 11V3.997M12 20.003V12M12 8.999V3.997M18.549 20.003v-4.001M18.549 13V3.997M2.996 14h4.91M9.545 8.999h4.91M16.093 16.002h4.91"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            ></path>
          </svg>
          <span> Filters </span>
        </div>
      </div>
      <!-- <div class="cat-toggle">
          <button class="btn-cate-toggle">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#5f6368"
            >
              <path
                d="M390-318.46 641.54-480 390-641.54v323.08ZM480.07-100q-78.84 0-148.21-29.92t-120.68-81.21q-51.31-51.29-81.25-120.63Q100-401.1 100-479.93q0-78.84 29.92-148.21t81.21-120.68q51.29-51.31 120.63-81.25Q401.1-860 479.93-860q78.84 0 148.21 29.92t120.68 81.21q51.31 51.29 81.25 120.63Q860-558.9 860-480.07q0 78.84-29.92 148.21t-81.21 120.68q-51.29 51.31-120.63 81.25Q558.9-100 480.07-100Zm-.07-60q134 0 227-93t93-227q0-134-93-227t-227-93q-134 0-227 93t-93 227q0 134 93 227t227 93Zm0-320Z"
              />
            </svg>
            Video
          </button>
          <button class="btn-cate-toggle">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              height="24px"
              viewBox="0 -960 960 960"
              width="24px"
              fill="#5f6368"
            >
              <path
                d="M330-250h300v-60H330v60Zm0-160h300v-60H330v60Zm-77.69 310Q222-100 201-121q-21-21-21-51.31v-615.38Q180-818 201-839q21-21 51.31-21H570l210 210v477.69Q780-142 759-121q-21 21-51.31 21H252.31ZM540-620v-180H252.31q-4.62 0-8.46 3.85-3.85 3.84-3.85 8.46v615.38q0 4.62 3.85 8.46 3.84 3.85 8.46 3.85h455.38q4.62 0 8.46-3.85 3.85-3.84 3.85-8.46V-620H540ZM240-800v180-180V-160v-640Z"
              />
            </svg>
            Card
          </button>
        </div> -->

      <div class="video-container">
        <div
          class="video-row"
          *ngIf="AllVideoData != null && AllVideoData.length > 0"
        >
          <div class="row-seprator" *ngFor="let item of AllVideoData">
            <app-video-post
              [video]="item"
              *ngIf="item?.VideoId > 0"
            ></app-video-post>
            <app-card-post
              [card]="item"
              *ngIf="item?.CardId > 0"
            ></app-card-post>
          </div>
        </div>
        <!-- <div class="row justify-content-center"
                    *ngIf="!isAllVideoLoaded">
                    <div class="col-md-auto col-auto">
                        <a class="cursor-pointer" (click)="showMore()">
                            <span class="btn-showmore">VIEW MORE</span>
                        </a>
                    </div>
                </div>
                <div class="uk-grid loader" *ngIf="isAllVideoLoading">
                    <div uk-spinner></div>
                    <p>Loading</p>
                </div> -->
      </div>
    </div>
  </section>
</div>
<!-- <div class="item" *ngIf="isShowLoader">
  <div class="overlay">
    <div class="loadercenter">
      <img
        src="{{ assetURL }}/assets/images/GIF/loading.gif"
        width="64"
        height="64"
        alt="Loading..."
      />
    </div>
  </div>
</div> -->
<div class="main_content container-fluid">
  <!-- <section class="all-videos section-divider text-center" *ngIf="isShowNoContent">
        <h2>Sorry no more videos available for now.</h2>
    </section> -->
</div>
